import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  absolute: PropTypes.bool,
};

const DismissButton = ({ className, absolute, ...props }) => {
  const classes = classNames({
    'btn-dismiss': true,
    'btn-dismiss-content': absolute,
    [className]: className,
  });

  return <button type="button" className={classes} {...props} />;
};

DismissButton.propTypes = propTypes;

export default DismissButton;
